import React, { useContext, createContext, PropsWithChildren } from 'react';
import {
  useDocumentViewer,
  UseDocumentViewerConfig,
} from '../hooks/documents/useDocumentViewer';

type DocumentViewerContextProps = ReturnType<typeof useDocumentViewer>;
export const DocumentViewerContext = createContext<DocumentViewerContextProps | null>(
  null
);

export const useDocumentViewerContext = () => {
  const context = useContext(DocumentViewerContext);

  if (context === null) {
    throw new Error(
      'useDocumentViewerContext called outside of a DocumentViewerProvider context'
    );
  }

  return context;
};

export const DocumentViewerProvider = ({
  licenseKey,
  inlineToolbarItems,
  styleSheets,
  children,
}: PropsWithChildren<UseDocumentViewerConfig>) => {
  const documentViewer = useDocumentViewer({
    licenseKey,
    inlineToolbarItems,
    styleSheets,
  });

  return (
    <DocumentViewerContext.Provider value={documentViewer}>
      {children}
    </DocumentViewerContext.Provider>
  );
};
